import { SelfServeBuilderPopupTypes } from 'Popups';

const { SIGNATURE } = SelfServeBuilderPopupTypes;

const getSuperScriptValue = (id, label, popups) => {
  let superscript = 0;

  const popupIdsWithSameTypeAndLabel = Object.keys(popups).filter(popupId => (
    popups[popupId].type === popups[id].type
    && popups[popupId].label.toLowerCase() === label.toLowerCase()
  ));

  if (popupIdsWithSameTypeAndLabel.length > 1) {
    const orderedPopupIdsWithSameLabel = popupIdsWithSameTypeAndLabel.sort((a, b) => (
      popups[a].timestamp - popups[b].timestamp
    ));
    superscript = orderedPopupIdsWithSameLabel.indexOf(id) + 1;
  }

  if (superscript === 0 && popups[id] && popups[id].type === SIGNATURE) {
    return 1;
  }
  return superscript;
};

export default getSuperScriptValue;



// WEBPACK FOOTER //
// ./src-react/SelfServeBuilderUtils/index.jsx